import React from 'react';
import { MapPin, Mail, Phone, ExternalLink } from 'lucide-react';

export default function TopbarView() {
  return (
    <div className="vj-topbar py-1 d-none d-md-block">
      <div className="container-fluid px-lg-4">
        <div className="d-flex justify-content-between align-items-center small">
          <div className="d-flex align-items-center gap-3 vj-topbar-info">
            <span className="d-flex align-items-center gap-1.5">
              <MapPin size={13} className="text-gold flex-shrink-0" />
              <span>4A, Raj Niwas Marg, Delhi – 110054</span>
            </span>
            <span className="d-none d-lg-flex align-items-center gap-1.5">
              <Mail size={13} className="text-gold flex-shrink-0" />
              <a href="mailto:vidyajyotic@gmail.com" className="vj-topbar-link">
                vidyajyotic@gmail.com
              </a>
            </span>
            <span className="d-flex align-items-center gap-1.5">
              <Phone size={13} className="text-gold flex-shrink-0" />
              <a href="tel:+919971186877" className="vj-topbar-link">
                (+91) 99711 86877
              </a>
            </span>
          </div>

          <div className="d-flex align-items-center gap-2">
            <a
              href="https://students.vidyajyoticollege.in"
              target="_blank"
              rel="noreferrer"
              className="vj-portal-tag"
            >
              Student Portal <ExternalLink size={11} />
            </a>
            <a
              href="https://library.vidyajyoticollege.in"
              target="_blank"
              rel="noreferrer"
              className="vj-portal-tag"
            >
              Library Portal <ExternalLink size={11} />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
